<app-kp-results-header
  [type]="type()"
  [stateKey]="stateKey()"
  [listState]="listStateService.state"
  [count]="resultCount()"
  [disabled]="controlsDisabled()"
  (typeChange)="handleTypeChange($event)"
>
  <app-button2
    appearance="secondary"
    size="m"
    [ariaLabel]="'Sort & filter: ' + sortLabel()"
    [matTooltip]="'Sort: ' + sortLabel()"
    appFormsListContextMenu
    [class]="
      sortActive() ? 'kp-sort-button [&>button]:border-primary-600 [&>button]:text-primary-600' : 'kp-sort-button'
    "
    [disabled]="controlsDisabled()"
    [stchPopoverDisabled]="controlsDisabled()"
    (contextMenuOpened)="sortMenuOpened.set($event)"
  >
    <app-icon class="shrink-0" name="filters" [size]="20" />
  </app-button2>
</app-kp-results-header>
<div class="list flex flex-col">
  <app-forms-hub-list
    [kind]="folder ? 'folder' : 'form'"
    [kpInteractions]="true"
    [filters]="state"
    [tenantItems]="contextTenantItems()"
    [notFoundTemplate]="resultsEmpty"
    (totalCountChange)="resultCount.set($event)"
    (itemActivate)="handleClickItem($event)"
    (itemOpen)="handleDoubleClickItem($event)"
  />
</div>
<ng-template #resultsEmpty><app-kp-results-empty [state]="emptyState()" [type]="type()" /></ng-template>
